export default __webpack_public_path__ + "static/media/IMG_0353.4921b547.jpg";